import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const declarantTypes: ISelectOption[] = [
  {
    id: '0',
    label: 'Контролирующий орган',
    value: 'Контролирующий орган',
  },
  {
    id: '1',
    label: 'Орган прокуратуры',
    value: 'Орган прокуратуры',
  },
  {
    id: '3',
    label: 'Иное',
    value: 'Иное',
  },
];
